<template>
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.vt_processor') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.vt_processor') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_system" @click.prevent="showVTVerarbeiter(null)">{{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="VTVerarbeiter"
            fileName="VTVerarbeiter"
            modelName="vtverarbeiter"
            deleteURL="todos/v1/delete_vtselbst/"
            editorPatchURL="/todos/v1/patch_vtselbst/"
            :columns="columns"
            :objects="vtseblstList"
            :exportColumns="[0, 1]"
            :editorCallback="true"
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showVTVerarbeiter"
            @editorUpdated="setVTSelbst"
            v-if="promiseFinished"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="!promiseFinished" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </div>
    <VTSelbst :currentVTSelbst="currentVTSelbst" :vtselbst-name-list="vtselbstNameList" @vtselbstUpdated="setVTSelbst">
      <template v-slot:fileUpload><fileUpload :commentObject="currentVTSelbst" modelName="vtverarbeiter" @attachmentUpdated="setVTSelbst" modelVerboseName="VTVerarbeiter"></fileUpload></template>
      <template v-slot:comments><comments :commentObject="currentVTSelbst" modelName="vtverarbeiter" @commentUpdated="setVTSelbst" modelVerboseName="VTVerarbeiter"></comments></template>
    </VTSelbst>

  </div>
</template>
<script>
  import service from '@/utils/request.js';
  import {mapMutations, mapState} from 'vuex';

  import datePicker from 'vue-bootstrap-datetimepicker';
  import { Uploader, Button } from 'vant';
  import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import comments from "@/components/component/CommentComponent.vue";
  import fileUpload from "@/components/component/FileUploadComponent.vue";
  import VTSelbst from "@/components/component/VTSelbstComponent.vue";
  import {newVTVerarbeiter, objectModalName} from "@/utils/enums";
  import {deepCopy} from "@/utils";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
  export default {
    components: {
      FingerPrintSpinner,
      VTSelbst,
      fileUpload,
      comments,
      DataTableDSMS, DisplayColumnsComponent, 'van-uploader': Uploader, 'van-button': Button, datePicker},
    data() {
      return {
        datetimeOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        vtseblstList: [],
        currentVTSelbst: newVTVerarbeiter,
        table: null,
        editor: null,
        promiseFinished: false,
      }
    },
    created() {
      this.getVTSelbst()
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, }),
      vtselbstNameList() {
        return this.vtseblstList.map(item => item.name)
      },

      columns() {
        return [
          {
            label: 'Nr.#',
            name: 'sequence',
            enableEditor: false,
            definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
          },
          {
            label: this.$t('name'),
            name: 'name',
            type: 'text',
            enableEditor: true,
            definition: { data: "name" },
          },
          {
            label: this.$t('data_controller'),
            name: 'controller',
            type: 'text',
            enableEditor: true,
            definition: { data: "controller" },
          },
          {
            label: this.$t('description'),
            name: 'description',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "description" },
          },
          {
            label: this.$t('legal_base.name'),
            name: 'legal_base',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "legal_base" },
          },
          {
            label: this.$t('tom'),
            name: 'toms',
            enableEditor: false,
            definition: { data: "toms" },
          },
          {
            label: this.$t('process_name'),
            name: 'process_name',
            type: 'textarea',
            className: 'dkl-font-13',
            attr: {
              rows: 8
            },
            enableEditor: true,
            definition: { data: "process_name" },
          },
          {
            label: this.$t('stand'),
            name: 'stand',
            type: 'text',
            enableEditor: false,
            definition: { data: "stand" },
          },
        ]},
    },
    mounted() {},
    updated () {},
    methods: {
      ...mapMutations({setEdit: 'SET_EDIT'}),
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
      },
      async setVTSelbst(vtObject) {
        const vtIndex = this.vtseblstList.findIndex(item => item.id === vtObject.id)
        if (vtIndex === -1) {
          this.vtseblstList = this.vtseblstList.map(item => {
            item.sequence = item.sequence + 1
            return item
          })
          this.vtseblstList.push(vtObject)
        } else {
          this.vtseblstList[vtIndex] = vtObject
        }
        this.table.clear().rows.add(this.vtseblstList).draw(false)
      },
      async getVTSelbst() {
        const that = this
        service.request({
          url: `todos/v1/vtselbst/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.vtseblstList = response.data;
          that.promiseFinished = true
        }).catch(function(err) {
          console.log(err);
          that.promiseFinished = true
        })
      },
      showVTVerarbeiter(vtID) {
        if (vtID != null) {
          this.currentVTSelbst = this.vtseblstList.filter(item => item.id === vtID)[0]
        } else {
          this.currentVTSelbst = deepCopy(newVTVerarbeiter)
        }
        $('#' + objectModalName.vtverarbeiter).modal('show')
      }
    }
  }
</script>
